const deepCopy = (sourceObject, destinationObject) => {
  for (var key in sourceObject) {
    if (
      sourceObject[key] === null ||
      sourceObject[key] === undefined ||
      typeof sourceObject[key] != "object"
    ) {
      destinationObject[key] = sourceObject[key];
    } else {
      destinationObject[key] = Array.isArray(sourceObject[key]) ? [] : {};
      deepCopy(sourceObject[key], destinationObject[key]);
    }
  }
};

const arrayEquals = (array1, array2, prop = null) => {
  if (array1 === array2) {
    return true;
  }

  if (!Array.isArray(array1) || !Array.isArray(array2)) {
    return false;
  }

  if (array1.length !== array2.length) {
    return false;
  }

  if (prop) {
    return array1.every((val, index) => val[prop] === array2[index][prop]);
  } else {
    return array1.every((val, index) => val === array2[index]);
  }
};

export const object = {
  equals: (obj1, obj2, keysToCheck) => {
    let ret = true;

    for (let index = 0; index < keysToCheck.length; index++) {
      const key = keysToCheck[index];
      const splitted = key.split(".");

      if (splitted.length > 1) {
        const newKey = splitted.slice(1).join(".");
        ret = object.equals(obj1[splitted[0]], obj2[splitted[0]], [newKey]);
        if (!ret) {
          break;
        }
      } else {
        if (Array.isArray(obj1)) {
          ret = arrayEquals(obj1, obj2, key);
          if (!ret) {
            break;
          }
        } else {
          if (!(key in obj1) || obj1[key] != obj2[key]) {
            ret = false;
            break;
          }
        }
      }
    }

    return ret;
  },
  isObjectEmpty: obj => {
    return !(
      obj &&
      Object.keys(obj).length === 0 &&
      obj.constructor === Object
    );
  },
  clone: obj => {
    var destinationObject = {};
    deepCopy(obj, destinationObject);
    return destinationObject;
  }
};

export default {
  object
};
